export class JsonArrayPlaceholder {
    arrayName: string = '';
    startIndex: number = 0;
    endIndex: number = 0;
    fullMatch: string = '';
    blockContent: string = '';
    negativeBlockContent: string = '';
    fullMatchWithNegative: string = '';
    hasNegativeBlock: boolean = false;
    isPairedNegative: boolean = false;
    isConditionalBlock: boolean = false;
    nestedKeys: string[] = [];
    nestedArrays: string[] = [];

    constructor() {}
}
